/* eslint-disable no-useless-concat */
import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { Paper, Icon } from "@mui/material";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { DELETE_INCO_TERM, INCO_TERM_ID } from "./Graphql";
import { KeyValuePair } from "../HOC/CustomComponents/KeyValuePair";
import { Globals } from "../HOC/Classes/Globals";
import Grid from "@mui/material/Unstable_Grid2";
import TitleAppBar from "../../Layout/TitleAppBar";
import { pushUrl } from "../HOC/CustomFunctions/pushUrl";
import LongMenu from "../../Layout/MenuAppBar";
import NotFound from "../../Error/NotFound";
import MutationWithDialog from "../HOC/CustomComponents/MutationWithDialog";
import { StyledLoading, classesLoad } from "../../GlobalStyles/LoadingStyle";
import { RootStyleView, classesView } from "../../GlobalStyles/ViewStyle";

const IncoTermView = (props) => {
  const id = props.match.params.id?.trim();
  const { t } = useTranslation();
  const user = Globals.user;
  const [openDelete, setOpenDelete] = useState(false);

  const openDeleteDialog = (type) => {
    setOpenDelete(true);
  };
  const { loading, data } = useQuery(
    gql`
      ${INCO_TERM_ID.query}
    `,
    {
      fetchPolicy: "network-only",
      variables: { id: parseInt(id) },
    }
  );
  const incoTermData = data?.incoTerm;

  const icons = [
    {
      id: "edit",
      action: () => pushUrl(props, `/admin/inco-terms/${id}/edit`),
      permission: user?.hasPermission("freight.inco_term.update"),
    },
    {
      id: "delete",
      action: openDeleteDialog,
      permission: user?.hasPermission("freight.inco_term.delete"),
    },
  ];
  return loading ? (
    <StyledLoading
      container
      item
      justifyContent="center"
      className={classesLoad.main}
    >
      <FullScreenLoading height={"100%"} />
    </StyledLoading>
  ) : !incoTermData ? (
    <NotFound />
  ) : (
    <>
      {openDelete && (
        <MutationWithDialog
          mutaion={DELETE_INCO_TERM.query}
          setOpenDelete={setOpenDelete}
          openDelete={openDelete}
          dialogTitle={t("deleteRecord")}
          dialogContent={t("deleteRecordMessage")}
          mutaionProps={{
            variables: { id: parseInt(id) },
          }}
          onCompleted={() => pushUrl(props, `/admin/inco-terms`)}
          onCompleteMessage={t("successfullyDeletedRecord")}
        />
      )}
      <TitleAppBar path={props.match.path}>
        <LongMenu icons={icons} />
      </TitleAppBar>
      <RootStyleView spacing={2} p={2} justifyContent="center">
        <Paper container className={classesView.paper} component={Grid}>
          <KeyValuePair title={t("code")} value={incoTermData?.code} />
          <KeyValuePair title={t("name")} value={incoTermData?.name} />
          <KeyValuePair
            title={t("shortName")}
            value={incoTermData?.shortName}
          />
          <KeyValuePair
            title={t("description")}
            value={incoTermData?.description}
          />
          <KeyValuePair
            title={t("air")}
            value={
              incoTermData?.air ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />
          <KeyValuePair
            title={t("land")}
            value={
              incoTermData?.land ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />

          <KeyValuePair
            title={t("ocean")}
            value={
              incoTermData?.ocean ? (
                <>
                  <Icon className={classesView.iconColor}>
                    check_circle_outline
                  </Icon>
                </>
              ) : (
                <>
                  <Icon color="error">highlight_off</Icon>
                </>
              )
            }
          />
          <KeyValuePair
            title={t("active")}
            value={
              incoTermData?.active ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("import")}
            value={
              incoTermData?.import ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("export")}
            value={
              incoTermData?.export ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("cc")}
            value={
              incoTermData?.cc ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("cp")}
            value={
              incoTermData?.cp ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
          <KeyValuePair
            title={t("pp")}
            value={
              incoTermData?.pp ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
        </Paper>
      </RootStyleView>
    </>
  );
};

export default IncoTermView;
